<template>
  <div class="main">
    <div class="content">


      <div class="nodata" v-if="doneList.length == 0 && waitList.length == 0">
        <van-empty v-if="noDataShow" description="没有查询到您的报告"/>
      </div>
      <div v-else style="width: 100%;">
        <div v-for="item in doneList" v-bind:key="item.serialNo">
          <van-card v-if="item.summaryStatus == '3' || reportAudit || reportImageAudit"
                    :tag="item.checkDate | checkDateFilter"
                    :title="item.name"
                    :desc="'报告日期：' + (item.summaryDate == null || item.summaryStatus !='3'?'报告未出':item.summaryDate)"
                    :thumb="require('@/assets/images/report.svg')"
                    style="font-size: 2.4em;background-color:#fff;margin: 15px;border-radius: 10px;box-shadow: 0 0 10px rgba(0,0,0,.2)"
          >
            <template #tags>
              <van-tag plain type="default"
                       style="background-color: transparent;line-height: 1.6em;">{{ hospiatlName }}
              </van-tag>
            </template>
            <template #footer>

              <van-button v-if="item.summaryStatus=='3'" type="info" size="mini" round
                          @click="toReportDetail(item)">
                <van-icon name="bars"/>
                报告详情
              </van-button>
              <van-button v-if="item.summaryStatus!='3' && (reportAudit || reportImageAudit)" type="primary" size="mini"
                          round @click="toReportDetail(item)">
                <van-icon name="bars"/>
                {{ reportAudit ? '检验' : '' }}
                {{ reportAudit && reportImageAudit ? ' | ' : '' }}{{ reportImageAudit ? '影像' : '' }}结果
              </van-button>
              <van-button v-if="!item.pdfGenerate && item.summaryStatus=='3'" type="warning" size="mini" plain round
                          @click="getPdfReport(item.serialNo)">
                <van-image
                    width="1.5em"
                    height="1.5em"
                    :src="require('@/assets/images/pdf_preview2.svg')"
                    style="vertical-align: middle"
                />
                获取PDF报告
              </van-button>
              <van-button v-if="item.pdfGenerate && item.summaryStatus=='3'" type="info" size="mini" round
                          @click="toReportPdf(item.serialNo)">
                <van-image
                    width="1.5em"
                    height="1.5em"
                    :src="require('@/assets/images/pdf_preview2.svg')"
                    style="vertical-align: middle"
                />
                预览
              </van-button>
              <van-button v-if="item.pdfGenerate && item.summaryStatus=='3'" type="default" size="mini" round
                          @click="downloadExportFile(item.serialNo)">
                <van-image
                    width="1.5em"
                    height="1.5em"
                    :src="require('@/assets/images/download_blue.svg')"
                    style="vertical-align: middle"
                />
                下载
              </van-button>
              <!--云胶片-->
              <van-button v-if="(VUE_APP_CLOUD_FILM || VUE_APP_CLOUD_FILM_DETAIL_URL) && item.isCloudFilm" type="info"
                          size="mini" round
                          @click="toCloudFilm(item.serialNo)">
                <van-image
                    width="1.5em"
                    height="1.5em"
                    :src="require('@/assets/images/download_blue.svg')"
                    style="vertical-align: middle"
                />
                云胶片
              </van-button>
            </template>
          </van-card>
        </div>
      </div>
    </div>

    <div class="footer">
      <van-tabbar v-model="active" active-color="#409EFF" inactive-color="#000">
        <van-tabbar-item icon="home-o" @click="toHome">首页</van-tabbar-item>
        <van-tabbar-item icon="user-o" @click="toUserinfo">个人中心</van-tabbar-item>
      </van-tabbar>
    </div>
  </div>
</template>

<script>
import {Dialog, Toast} from "vant";
import {getReportBase64Strs, getReports, getPdfReport} from '@/api/module/user'
import {encrypt, decrypt} from '../../assets/utils/cryptoUtil.js'
import {getHospitalCode, getQuestionIsTrue} from "@/api/module";
import crypto from "crypto";

export default {
  name: "index",
  data() {
    return {
      active: 0,
      reportList: [],
      doneList: [],//已完成报告
      waitList: [],//待生成报告
      user: {},//登录信息
      hospiatlName: window.g.VUE_APP_HOSPITALNAME,
      hospiatlPhone: window.g.VUE_APP_PHONE,
      reportAudit: window.g.VUE_APP_REPOT_AUDIT,
      reportImageAudit: window.g.VUE_APP_REPOT_IMAGE_AUDIT,
      noDataShow: false,
      // 控制是否显示前往答题的弹框
      goAnswerPopShow: window.g.VUE_APP_GO_ANSWER_POP_SHOW,
      // 跳转类型
      goToType: 0,
      VUE_APP_CLOUD_FILM: window.g.VUE_APP_CLOUD_FILM,
      reportListQueryTips: window.g.VUE_APP_REPORT_QUERY_TIPS, // 报告查询提示框
      reportListQueryTipsDirection: window.g.VUE_APP_REPORT_QUERY_TIPS_DIRECTION,  // 报告查询列表弹框提示 提示框文字居中还是做左对齐
      VUE_APP_CLOUD_FILM_DETAIL_URL: window.g.VUE_APP_CLOUD_FILM_DETAIL_URL, // 带详情页的云胶片
    };
  },
  created() {
    if (this.reportListQueryTips) { // 是否显示报告查询提示框 20241119 新增 ZLS
      this.goAnswerPop()
    }
    this.user = JSON.parse(localStorage.getItem("loginuser"))
    this.getList()
  },
  filters: {
    checkDateFilter(checkDate) {
      if (checkDate != undefined && checkDate != "") {
        return checkDate.substr(0, 4) + '年'
      }
    }
  },
  methods: {
    /*进入页面弹框 ZLS 20241119 新增 */
    goAnswerPop() {
      Dialog.alert({
        title: '提示',
        message: this.reportListQueryTips,
        messageAlign: 'left'
      }).then(() => {
        // on close
      })
    },
    /* 查询报告列表 */
    getList() {
      let param = {
        id: this.user.id,
        patientid: this.user.patientid
      }
      getReports(param).then(res => {
        this.noDataShow = true
        if (res.code == 200) {
          if (res.data == -1) {
            Dialog({
              message: res.msg + ',请立即联系体检中心处理，电话：' + this.hospiatlPhone,
              theme: 'round-button',
            });
          } else {
            this.reportList = res.data
            this.doneList = res.data
            this.reportList.forEach(item => {
              // 不等待总审
              // if(this.reportAudit && item.reportFull){
              //   this.doneList.push(item)
              // }
              //已总审（完成报告复核的）
              // if (item.summaryStatus == '3') {
              //   this.doneList.push(item)
              // }
            })
          }
        }
      })
    },
    toHome() {
      this.$router.push({name: 'home'})
    },
    toUserinfo() {
      this.$router.push({name: 'userinfo'})
    },
    toOrders() {
      this.$router.push({name: 'orders'})
    },
    wait() {
      Dialog.alert({
        title: '温馨提示',
        message: '此份报告还未生成，请留意手机短信或咨询体检中心',
      }).then(() => {
      });
    },
    toReportDetail(item) {
      // 跳转报告详情
      this.goToType = 0
      // 判断是否开启 弹出框提示是否前往答 满意度调查问卷 并且是 总检后
      if (this.goAnswerPopShow && item.summaryStatus == '3') {
        this.questionIsTrue(item.serialNo)
      } else {
        this.$router.push({name: 'reportdetail', query: {physicalCode: encrypt(item.serialNo)}})
      }
    },
    //跳转满意度调查问卷确认
    questionIsTrue(serialNo) {
      getQuestionIsTrue({serialNo: serialNo}).then(res => {
        if (res.data) {
          Dialog.confirm({
            title: '温馨提示',
            message: '您还有一份满意度调查问卷未完成，请问是否前往答题？',
          }).then(() => {
            this.$router.push({name: 'survey', query: {serialNo: serialNo}})
          }).catch(() => {
            if (this.goToType === 0) {
              this.$router.push({name: 'reportdetail', query: {physicalCode: encrypt(serialNo)}})
            } else if (this.goToType === 1) {
              this.toReportPdf(serialNo)
            }
          });
        } else {
          if (this.goToType === 0) {
            this.$router.push({name: 'reportdetail', query: {physicalCode: encrypt(serialNo)}})
          } else if (this.goToType === 1) {
            this.toReportPdf(serialNo)
          }
        }
      })
    },
    getPdfReport(serialNo) {
      let param = {
        institutionid: window.g.VUE_APP_INSTITUTIONID,
        serialno: encrypt(serialNo)
      }
      getPdfReport(param).then(res => {
        if (res.code == 200) {
          if (res.data == "OK") {
            //报告PDF文件生成成功
            this.doneList.forEach(item => {
              if (item.serialNo == serialNo) {
                item.pdfGenerate = true
              }
            })
          } else {
            Toast("生成失败，请联系系统管理员")
          }
        }
      })
    },
    //预览PDF报告
    toReportPdf(serialNo) {
      // 如果开启 弹出框提示是否前往答 满意度调查问卷
      if (this.goAnswerPopShow && this.goToType !== 1) {
        // 第一次进入将跳转类型改为1
        this.goToType = 1
        this.questionIsTrue(serialNo)
      } else {
        // 第二次进入将跳转类型改为0, 防止跳转没成功类型状态没变更导致无法二次调用满意度弹出框
        this.goToType = 0
        let param = {
          patientid: this.user.patientid,
          serialno: encrypt(serialNo)
        }
        getReportBase64Strs(param).then(res => {
          if (res.code == 200) {
            let base64Str = res.data
            if (base64Str != "") {
              this.$router.push({name: 'reportpdf', query: {base64Str: base64Str}})
            } else {
              Dialog.alert({
                title: '温馨提示',
                message: '此份报告还未生成，请留意手机短信或咨询体检中心',
              }).then(() => {
              });
            }
          }
        })
      }
    },
    downloadExportFile(serialNo) {
      serialNo = encodeURIComponent(encrypt(serialNo))
      let patientId = encodeURIComponent(this.user.patientid)
      this.$router.push({name: 'reportdownload', query: {serialNo: serialNo, patientId: patientId}})
    },
    getDay() {
      let time = new Date(),
          year = time.getFullYear(),
          month = time.getMonth() + 1,
          day = time.getDate(),
          timeStem = time.getTime()
      return `${year}/${month}/${day}/${timeStem}.PDF`
    },
    appSource() {
      const u = navigator.userAgent;
      //const app = navigator.appVersion;
      //const isAndroid = u.indexOf('Android') > -1 || u.indexOf('Linux') > -1; //g
      const isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); //ios终端
      console.log("isiOS:" + isiOS);
      if (isiOS) {
        return "ios";
      } else {
        return "andriod";
      }
    },
    //跳转云胶片
    toCloudFilm(serialno) {
      // zls 20250711新增 柳州广妇儿院云胶片功能
      if (this.VUE_APP_CLOUD_FILM_DETAIL_URL) {
        this.$router.push({name: 'cloudFilmGZLFE', query: {seroalno: serialno}})
        return
      }

      //accesskey#{accesskey}hisId2#{hisId2}hospitalId#{hsCode}timeStamp#{timeStamp}accessSecret#{accessSecret}
      let timeStamp = new Date().getTime();
      let signStr = "accesskey" + this.VUE_APP_CLOUD_FILM.accessKey;
      signStr += "hisId2hisId2";
      signStr += "hospitalId" + this.VUE_APP_CLOUD_FILM.hscode;
      signStr += "timeStamp" + timeStamp;
      signStr += "accessSecret" + this.VUE_APP_CLOUD_FILM.accessSecret;
      console.log("signStr:" + signStr)
      let sign = crypto.createHash('md5').update(signStr, 'utf-8').digest('hex');
      // sign = sign.toUpperCase()
      let url = this.VUE_APP_CLOUD_FILM.url + "?hsCode=" + this.VUE_APP_CLOUD_FILM.hscode + "&queryKey=hisId2&queryValue=" + serialno + "&accessKey=" + this.VUE_APP_CLOUD_FILM.accessKey + "&timeStamp=" + timeStamp + "sign=" + sign;
      window.location.href = url;
    }
  }
}
</script>

<style scoped>
.main {
  width: 100%;
  height: 100%;
  overflow-x: hidden;
  overflow-y: scroll;
  background: #F5F5F5;
}

.nodata {
  width: 100%;
  height: 50rem;
  display: flex;
  justify-content: center;
  align-items: center;
}

.content {
  width: 100%;
  display: flex;
  flex-flow: column;
  align-items: center;
  padding-bottom: 16rem;
}

.item {
  width: 49%;
  height: 45rem;
  background: #fff;
  margin-top: 1.5rem;
  border-radius: 1rem;
  box-shadow: 0 0 10px #afacac;
}


.list {
  width: 90%;
  background: #fff;
  border-radius: 1rem;
  box-shadow: 0 0 5px #C6E2FF;
  display: flex;
  flex-flow: column;
  margin-top: 1.5rem;
  padding: 2rem;
}

.van-card__thumb {
  width: 4em;
  height: 4em;
}

.van-card__content {
  min-height: 10vw;
}

.van-card__title.van-multi-ellipsis--l2 {
  font-weight: 700;
}

.van-tag--danger {
  background-color: #576b95;
  opacity: .7;
}

.van-card__tag {
  position: absolute;
  top: 18px;
  left: 0;
}

</style>
